module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n	.width-regulator td:nth-child(1) {\n		width: 15%;\n	}\n\n	.width-regulator td:nth-child(2) {\n		width: 40%;\n	}\n\n	.width-regulator td:nth-child(3) {\n		width: 10%;\n	}\n\n	.width-regulator td:nth-child(4) {\n		width: 10%;\n	}\n\n	.width-regulator td:nth-child(5) {\n		width: 10%;\n	}\n\n	.width-regulator td:nth-child(6) {\n		width: 15%;\n	}\n</style>\n\n<table class=\"w100 gl-report__table width-regulator\">\n	<thead>\n	<tr>\n		<td>Время трекера</td>\n		<td>Широта / Долгота</td>\n		<td>Скорость, км/ч</td>\n		<td>Одометр, км</td>\n		<td>ГЛОНАСС / GPS</td>\n		<td>Время сервера</td>\n	</tr>\n	</thead>\n</table>\n\n<div class=\"wh100\">\n	<div class=\"cell__abs_container\">\n		<div class=\"cell__abs overflow-y__auto\">\n\n			<table class=\"w100 gl-striped__table gl-report__table width-regulator\">\n				<tbody>\n				")
    ;  if (data) { 
    ; __append("\n				")
    ;  Util.each(data, function (item) { 
    ; __append("\n				<tr>\n					<td>")
    ; __append(escapeFn( Date.fromTZ(item.datetime).format() ))
    ; __append("</td>\n					<td>")
    ; __append(escapeFn( item.lat ))
    ; __append(" / ")
    ; __append(escapeFn( item.lon ))
    ; __append("</td>\n					<td>")
    ; __append(escapeFn( item.speed ))
    ; __append("</td>\n					<td>")
    ; __append(escapeFn( item.odometer ))
    ; __append("</td>\n					<td>")
    ; __append(escapeFn( item.satsglonass ))
    ; __append(" / ")
    ; __append(escapeFn( item.satsgps ))
    ; __append("</td>\n					<td>")
    ; __append(escapeFn( Date.fromTZ(item.createddatetime).format() ))
    ; __append("</td>\n				</tr>\n				")
    ;  }); 
    ; __append("\n				")
    ;  } 
    ; __append("\n				</tbody>\n			</table>\n		</div>\n	</div>\n</div>\n")
  }
  return __output.join("");

}